export function upiEnabledFor(country: string, settings: any[]): boolean {
  return String(country || '').trim().toUpperCase() === 'IN' && settings.some(s =>
    s.setting_key === 'UPI_COLLECTION_MODE' && s.enabled !== false &&
    ['MANUAL', 'AUTOMATED', 'HYBRID'].includes(s.config?.mode));
}
